import { Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import User from './pages/User';
import Reports from './pages/Reports';
import DeviceLocator from './pages/DeviceLocator';
import VendorMaster from './pages/vendor/VendorMaster';
import DeviceVendorMapping from './pages/vendor/DeviceVendorMapping';
import Payment from './pages/vendor/Payment';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import TicketManagement from './pages/TicketManagement';
import { useAuth } from './context/AuthContext';

function App() {
  const { user } = useAuth();
  const role = user?.role;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="devices" element={<Devices />} />
        <Route path="user" element={<User />} />
        <Route path="reports" element={<Reports />} />
        <Route path="device-locator" element={<DeviceLocator />} />
        <Route path="vendor/master" element={<VendorMaster />} />
        <Route path="vendor/device-mapping" element={<DeviceVendorMapping />} />
        <Route path="vendor/payment" element={<Payment />} />
        <Route path="ticket-management" element={<TicketManagement role={role} />} />
      </Route>
    </Routes>
  );
}

export default App;
